module.exports = __webpack_public_path__ + "static/media/alexa_logo_horizontal.d546704b.svg";